export default __webpack_public_path__ + "2aea0c9d4fe02465979ff247b89b9212.svg";